export default "<app-map [longitude]=\"-72\" [latitude]=\"43\" [zoom]=\"5\" [mapType]=\"'roadmap'\"></app-map>\n"